import { defineMessage } from "react-intl"

export const YES_NO_BUTTON_OPTIONS = [
  { label: defineMessage({ defaultMessage: "Yes" }), value: "YES" },
  { label: defineMessage({ defaultMessage: "No" }), value: "NO" }
]
